module.exports = __webpack_public_path__ + "img/ClassicAmericanCar300x300.0d88d6bc.jpg";